<script>
    import MenuButton from './MenuButton.svelte'
    import SideBar from '../lib/SideBar.svelte'
    import { onMount } from 'svelte'
    import { Mediator } from '../lib/mediator'
    import TopBarClipboard from './TopBarClipboard.svelte'
    import TopBarDropDown from './TopBarDropDown.svelte'
    import TopBarColorMode from './TopBarColorMode.svelte' 
    import TopBarCancel from './TopBarCancel.svelte'
    
    let open = false

    let isHelp = false
    let menuBarHeight = '60px'

    function selected() {
        open = false
    }

    onMount(() => {

    })
</script>

<div style="z-index: 1001;" class="toobar primary">
    <header class="fixed transparent max">
    <nav class="right-align">
        <MenuButton bind:open />    
        <TopBarDropDown />
        <div class="max">
            <TopBarColorMode />
        </div>
    </nav>
    </header>
    <SideBar on:selected={selected} bind:open />
</div>

<!-- <div class="w3-top" style="height:60px;z-index:1">
    <div
        class="w3-bar ddt-topbar w3-large w3-mobile"
        style="z-index:1;width:100%;height:{menuBarHeight};"
    >
        <div class="w3-row" style="width:100%;height:60px;">
            <div class="w3-col s12 m1 l1">
                <MenuButton bind:open />
            </div>

            <div class="w3-col s12 m3 l3">
                <div
                    class="w3-container w3-cell w3-cell-middle w3-align-left"
                    style="height:60px;"
                >
                </div>
            </div>

            <div class="w3-col s12 m1 l1">
                <TopBarDropDown></TopBarDropDown>
            </div>

            {#if isHelp}
                <TopBarHelp></TopBarHelp>
            {/if}
        </div>
    </div>
</div>
<SideBar on:selected={selected} bind:open />
 -->